import s from "../clinic.module.css";
import { Button, Field, Input, Select } from "../../ui";

function fmtPrice(n) {
  if (n == null || n === "") return "";
  return `${Number(n).toLocaleString("ru-RU")} ₽`;
}

export default function MembershipsStepForm({
  plans,
  planForm,
  onPlanFormChange,
  onAddPlan,
  adding,
  onContinue,
  saving,
  submitLabel = "Продолжить",
}) {
  const canContinue = plans.length > 0;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (canContinue) onContinue(e);
      }}
      className={[s.onboardingForm, s.onboardingMembershipsForm].join(" ")}
    >
      <p className={s.onboardingGroupsHint}>
        Создайте хотя бы один тариф — по занятиям или по сроку. На следующем шаге
        можно выдать абонемент первому клиенту или пропустить.
      </p>

      <div className={s.onboardingMembershipAdd}>
        <Field label="Название тарифа">
          <Input
            value={planForm.name}
            onChange={(e) =>
              onPlanFormChange({ ...planForm, name: e.target.value })
            }
            placeholder="8 занятий"
          />
        </Field>
        <Field label="Тип">
          <Select
            value={planForm.plan_type}
            onChange={(e) =>
              onPlanFormChange({ ...planForm, plan_type: e.target.value })
            }
          >
            <option value="visits">По занятиям</option>
            <option value="time">По сроку</option>
          </Select>
        </Field>
        {planForm.plan_type === "visits" ? (
          <>
            <Field label="Количество занятий">
              <Input
                type="number"
                min={1}
                value={planForm.visits_count}
                onChange={(e) =>
                  onPlanFormChange({
                    ...planForm,
                    visits_count: e.target.value,
                  })
                }
              />
            </Field>
            <Field
              label="Срок действия (дней)"
              hint="После этой даты абонемент истечёт, даже если остались занятия"
            >
              <Input
                type="number"
                min={1}
                value={planForm.duration_days}
                onChange={(e) =>
                  onPlanFormChange({
                    ...planForm,
                    duration_days: e.target.value,
                  })
                }
                placeholder="30"
              />
            </Field>
          </>
        ) : (
          <Field label="Срок (дней)">
            <Input
              type="number"
              min={1}
              value={planForm.duration_days}
              onChange={(e) =>
                onPlanFormChange({
                  ...planForm,
                  duration_days: e.target.value,
                })
              }
            />
          </Field>
        )}
        <Field label="Цена, ₽">
          <Input
            type="number"
            min={0}
            value={planForm.price}
            onChange={(e) =>
              onPlanFormChange({ ...planForm, price: e.target.value })
            }
            placeholder="4000"
          />
        </Field>
        <Button type="button" onClick={onAddPlan} disabled={adding}>
          {adding ? "…" : "+ Добавить тариф"}
        </Button>
      </div>

      <section className={s.onboardingVenueListBlock} aria-live="polite">
        <h4 className={s.onboardingVenueListTitle}>
          Тарифы ({plans.length})
        </h4>
        {plans.length === 0 ? (
          <p className={s.onboardingVenueListEmpty}>Пока нет тарифов</p>
        ) : (
          <ul className={s.onboardingGroupsList}>
            {plans.map((p) => (
              <li key={p.id} className={s.onboardingGroupListCard}>
                <div className={s.onboardingGroupListCardBody}>
                  <strong>{p.name}</strong>
                  <span>
                    {p.plan_type === "visits"
                      ? `${p.visits_count} зан.${p.duration_days ? ` · ${p.duration_days} дн.` : ""}`
                      : `${p.duration_days} дн.`}
                    {p.price != null ? ` · ${fmtPrice(p.price)}` : ""}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </section>

      <div className={s.onboardingSheetFoot}>
        <Button
          type="submit"
          disabled={!canContinue || saving}
          className={s.onboardingSubmitBtn}
          block
        >
          {saving ? "Сохранение…" : submitLabel}
        </Button>
      </div>
    </form>
  );
}
